import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { locationFields } from './common/locationFields';
import { ghgCategoryField } from './common/sharedFields';
import { msg } from '@lingui/core/macro';
import {
  distanceQuantityField,
  vehicleCategoryField,
  vehiclePowertrainTypeField,
  vehicleQuantityField,
  electricityEfficiencyField,
  fuelEfficiencyField,
} from './common/travelFields';
import { distanceUnitField } from './common/travelFields';
import { genericUnitField } from './common/sharedFields';

export const ceeVehiclesMetadata = {
  displayName: msg({
    message: 'CEE Vehicles',
    context: 'Activity data schema name for CEE Vehicles',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ghg_category_id: ghgCategoryField,
    distance_quantity: distanceQuantityField,
    distance_unit: distanceUnitField,
    electricity_efficiency: electricityEfficiencyField,
    electricity_efficiency_unit: genericUnitField,
    fuel_efficiency: fuelEfficiencyField,
    fuel_efficiency_unit: genericUnitField,
    vehicle_category: vehicleCategoryField,
    vehicle_make: {
      displayName: msg({
        message: 'Vehicle make',
        context: 'The make of the vehicle',
      }),
      externalDescription: msg({
        message: 'The make of the vehicle',
        context: 'Vehicle make description',
      }),
    },
    vehicle_model: {
      displayName: msg({
        message: 'Vehicle model',
        context: 'The model of the vehicle',
      }),
      externalDescription: msg({
        message: 'The model of the vehicle',
        context: 'Vehicle model description',
      }),
    },
    vehicle_powertrain_type: vehiclePowertrainTypeField,
    vehicle_quantity: vehicleQuantityField,
    // NOTE: quantity does not exist on the BAT but vehicle_quantity is
    // renamed to quantity in the BART-EM matching process
    quantity: vehicleQuantityField,
    vehicle_year: {
      displayName: msg({
        message: 'Vehicle year',
        context: 'The year of the vehicle',
      }),
      externalDescription: msg({
        message: 'The year of the vehicle',
        context: 'Vehicle year description',
      }),
    },
  },
} as const satisfies BatMetadataConfigEntry;
